import { WaitlistIcon } from "@xola/icons";
import { PurchaseItemStatus } from "common";
import React from "react";
import { Purchase, WaitlistItem } from "types";
import { Currency } from "../../../../Common/Currency";
import { PurchaseProductImage } from "../../../../PurchasesMenu/PurchaseProductImage";
import { StatusIcon } from "../../../../PurchasesMenu/PurchaseStatusIcon";
import { TimelineItem, TimelinePill } from "../../../../PurchasesMenu/Timeline/TimelineItem";
import { PurchaseDetails } from "./PurchaseTimelineItem";

interface WaitlistTimelineItemProps {
    change: Purchase;
    showDate?: boolean;
}

export const WaitlistTimelineItem = ({ change: purchase, showDate = false }: WaitlistTimelineItemProps) => {
    const audit = {
        createdAt: purchase.createdAt,
        createdBy: purchase.createdBy,
    };

    return (
        <TimelineItem
            title="New Waitlist"
            audit={audit}
            icon={<WaitlistIcon />}
            color="primary"
            showDate={showDate}
            purchase={purchase}
            badge={<StatusIcon displayText displayTextForAllStatus item={purchase as any} />}
        >
            <div className="flex items-center">
                <TimelinePill className="relative">
                    <div className="flex items-center space-x-4 p-2">
                        <div className="flex min-w-72 items-center">
                            <div className="relative mr-3 flex">
                                <PurchaseProductImage purchase={purchase} />
                            </div>

                            <PurchaseDetails purchase={purchase} />
                        </div>
                        <h2 className="ml-4">
                            <Currency shouldRemoveTrailingZeroes={false}>{purchase.amount}</Currency>
                        </h2>
                    </div>
                </TimelinePill>
            </div>
        </TimelineItem>
    );
};

WaitlistTimelineItem.supportsAudit = (item: WaitlistItem) => {
    return item?.status === PurchaseItemStatus.WAITLIST_CREATED;
};
